import type { OrderDocumentCompleteness } from '../../types/orderDocumentCompleteness';

type State = OrderDocumentCompleteness['checks'][number]['state'];
export const completenessStateColor: Record<State, string> = {
  MISSING: 'gold', PARTIAL: 'orange', COMPLETE: 'green', UNKNOWN: 'default',
};

export function completenessSummary(value?: OrderDocumentCompleteness, status?: string) {
  if (!value) return 'unknown';
  if (value.checks.some(check => check.state !== 'COMPLETE')) return 'pending';
  if (value.checks.length) return 'complete';
  return status === 'CANCELLED' || status === 'ON_HOLD' ? 'notApplicable' : 'notExpected';
}
